<template>
  <div>
    <BaseTitle :title="type === 'teacher' ? $t('content.anal_teacher') : $t('content.anal_student')" />
    <v-row>
      <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
      <v-col cols="12" md="auto">
        <v-card class="pa-5">
          <h3 class="role-title">{{ type === 'teacher' ? $t('content.anal_teacher') : $t('content.anal_student') }}</h3>
          <ul class="role-list">
            <li v-for="data in menus" :key="data.id" :class="{ active: currentMenus == data.id }" @click="changeData(data.id)">
              <svg-icon icon="anal_icon" class="primary--text mr-3" />
              <span class="role-list-text">{{ data.name }}</span>
            </li>
          </ul>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5">
          <!-- category teacher -->
          <template v-if="currentMenus === 1 && type === 'teacher'">
            <div class="ml-5 mr-5">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addCategory">{{ $t('add') }}</v-btn>
                </div>

                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-text-field v-model="searchCategories" :label="$t('search')" @change="getData" clearable>
                    <template #prepend-inner>
                      <svg-icon icon="ic-search" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
            <div v-for="item in listDataCategory" :key="item.analyticalCategoryId">
              <v-row class="border-item">
                <v-col md="2" align="center">
                  <div class="mt-5 ml-5">
                    <svg-icon icon="anal_icon" width="40" height="40" class="primary--text" />
                    <v-divider vertical></v-divider>
                  </div>
                </v-col>
                <v-col md="9" class="mt-3">
                  <div class="d-block">
                    <h3 class="d-inline">
                      <span class="header-content"> {{ item.categoryName }} </span>
                    </h3>
                  </div>
                  <div class="d-block">
                    <div>
                      <span class="body-content">
                        <span class="mr-3">
                          {{ $t('content.min_value') }}:
                          <strong>{{ item.valueMin }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('content.max_value') }}:
                          <strong>{{ item.valueMax }}</strong>
                        </span>
                        |
                        <span class="mr-3"> {{ $t('form.desc') }}: </span>
                        <td>
                          <article v-html="item.description" />
                        </td>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex"></div>
                </v-col>
                <v-col md="1" v-if="item.editable === true">
                  <template>
                    <div class="pa-5">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span dark v-bind="attrs" v-on="on">
                            <svg-icon icon="ic-moreaction-black" class="mt-1" />
                          </span>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="text-dropdown" @click="editCategory(item.analyticalCategoryId)">{{
                              $t('edit')
                            }}</v-list-item-title>
                          </v-list-item>
                          <div>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item.analyticalCategoryId)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </div>

            <NoData v-if="!listDataCategory.length" />
          </template>

          <!-- category student -->
          <template v-if="currentMenus === 1 && type === 'student'">
            <div class="ml-5 mr-5">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addCategory">{{ $t('add') }}</v-btn>
                </div>

                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-text-field v-model="searchCategories" :label="$t('search')" @change="getData" clearable>
                    <template #prepend-inner>
                      <svg-icon icon="ic-search" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
            <div v-for="item in listDataCategory" :key="item.analyticalCategoryStudentId">
              <v-row class="border-item">
                <v-col md="2" align="center">
                  <div class="mt-5 ml-5">
                    <svg-icon icon="anal_icon" width="40" height="40" class="primary--text" />
                    <v-divider vertical></v-divider>
                  </div>
                </v-col>
                <v-col md="9" class="mt-3">
                  <div class="d-block">
                    <h3 class="d-inline">
                      <span class="header-content"> {{ item.categoryName }} </span>
                    </h3>
                  </div>
                  <div class="d-block">
                    <div>
                      <span class="body-content">
                        <span class="mr-3">
                          {{ $t('content.file.date_created') }}:
                          <strong>{{ item.createdAt }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('content.by') }}:
                          <strong>{{ item.createdBy }}</strong>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex"></div>
                </v-col>
                <v-col md="1" v-if="item.editable === true">
                  <template>
                    <div class="pa-5">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span dark v-bind="attrs" v-on="on">
                            <svg-icon icon="ic-moreaction-black" class="mt-1" />
                          </span>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="text-dropdown" @click="editCategory(item.analyticalCategoryStudentId)">{{
                              $t('edit')
                            }}</v-list-item-title>
                          </v-list-item>
                          <div>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item.analyticalCategoryStudentId)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </div>

            <NoData v-if="!listDataCategory.length" />
          </template>

          <!-- quiz teacher -->
          <template v-if="currentMenus === 2 && type === 'teacher'">
            <div class="d-flex align-center justify-space-between mb-6">
              <div>
                <v-btn v-if="currentIdQuizMenu === 0" color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addTemplate">{{
                  $t('content.add_template')
                }}</v-btn>
              </div>
              <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
              <div>
                <v-text-field v-if="currentIdQuizMenu === 0" v-model="searchTemplate" clearable :label="$t('search')" @change="getData">
                  <template #prepend-inner>
                    <svg-icon icon="ic-search" class="primary--text mr-3" />
                  </template>
                </v-text-field>
                <v-text-field v-else v-model="searchQuiz" :label="$t('search')" clearable @change="getData">
                  <template #prepend-inner>
                    <svg-icon icon="ic-search" class="primary--text mr-3" />
                  </template>
                </v-text-field>
              </div>
            </div>
            <div>
              <v-tabs grow v-model="currentIdQuizMenu" background-color="#00BF63" color="white" slider-color="primary" dark>
                <v-tab
                  v-for="data in listQuiz"
                  :key="data.idQuizMenu"
                  v-model="currentIdQuizMenu"
                  :class="{ active: currentIdQuizMenu == data.idQuizMenu }"
                  @click="changeDataQuiz(data.idQuizMenu)"
                >
                  <div class="template-text">
                    {{ data.name }}
                  </div>
                </v-tab>
              </v-tabs>
              <!-- template -->
              <template v-if="currentIdQuizMenu === 0">
                <div class="pa-3">
                  <div v-for="item in listTemplate" :key="item.analyticalTemplateId">
                    <v-row class="border-item">
                      <v-col md="11" class="mt-3">
                        <div class="d-block">
                          <h3 class="d-inline">
                            <span class="header-content"> {{ item.templateName }} </span>
                          </h3>
                        </div>
                        <div class="d-flex"></div>
                      </v-col>
                      <v-col md="1">
                        <template>
                          <div class="pa-5">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <span dark v-bind="attrs" v-on="on">
                                  <svg-icon icon="ic-moreaction-black" class="mt-1" />
                                </span>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-list-item-title class="text-dropdown" @click="useTemplate(item.analyticalTemplateId)">{{
                                    $t('content.use_template')
                                  }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title class="text-dropdown" @click="editTemplate(item.analyticalTemplateId)">{{
                                    $t('edit')
                                  }}</v-list-item-title>
                                </v-list-item>
                                <div v-if="item.deleteable === true">
                                  <v-list-item>
                                    <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item.analyticalTemplateId)">{{
                                      $t('table.delete')
                                    }}</v-list-item-title>
                                  </v-list-item>
                                </div>
                              </v-list>
                            </v-menu>
                          </div>
                        </template>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <NoData v-if="!listTemplate.length" />
              </template>
              <!-- quiz -->
              <template v-if="currentIdQuizMenu === 1">
                <div class="pa-3 ">
                  <div class="master-quiz pa-5 mt-4" v-for="item in listQuizData" :key="item.analyticalQuitionnaireId">
                    <v-row>
                      <v-col md="10" class="d-flex d-inline">
                        <span class="d-block text-quiz-bottom mb-2 mr-8 mt-1">{{ item.quitionnaireName }} </span>
                        <div>
                          <span class="d-block text-quiz-bottom mb-2">Status </span>
                          <strong v-if="item.published === false" style="color: #CE8800;font-size: 12px;">Unpublish</strong>
                          <strong v-if="item.published === true" style="color: #6DD400;font-size: 12px;">Publish</strong>
                        </div>
                      </v-col>
                      <v-col md="2">
                        <v-btn text @click="editQuiz(item.analyticalQuitionnaireId)"><svg-icon icon="edit" small class="primary--text"/></v-btn>
                        <!-- Dialog Delete Course -->
                        <v-dialog v-model="dialogEditQuiz" persistent max-width="607">
                          <v-card>
                            <v-card-title class="headline secondary white--text">
                              {{ $t('content.edit_quiz_date') }}
                            </v-card-title>
                            <form @submit.prevent="editQuizSubmit">
                              <v-card-subtitle class="headline d-flex justify-center pa-5">
                                <v-row class="pa-5">
                                  <v-row>
                                    <v-col md="6" class="py-0">
                                      <form-group :name="$t('form.date')" no-gutter>
                                        <template slot-scope="{ attrs }">
                                          <v-menu
                                            ref="pickerDate"
                                            v-model="pickerDate"
                                            :close-on-content-click="false"
                                            :return-value.sync="pickerDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                          >
                                            <template #activator="{ on, attrs:attrActivator }">
                                              <v-text-field
                                                v-model="formTempEditQuiz.dueDate"
                                                :label="$t('form.date')"
                                                readonly
                                                v-bind="{ ...attrActivator, ...attrs }"
                                                v-on="on"
                                              >
                                                <template #append>
                                                  <svg-icon icon="calendar" class="primary--text mr-3" />
                                                </template>
                                              </v-text-field>
                                            </template>
                                            <v-date-picker v-model="formTempEditQuiz.dueDate" :locale="$i18n.locale">
                                              <v-spacer />
                                              <v-btn text color="primary" @click="pickerDate = false">{{ $t('cancel') }}</v-btn>
                                              <v-btn text color="primary" @click="pickerDate = false">{{ $t('ok') }}</v-btn>
                                            </v-date-picker>
                                          </v-menu>
                                        </template>
                                      </form-group>
                                    </v-col>
                                    <v-col md="6" class="py-0">
                                      <form-group :name="$t('form.time')" no-gutter>
                                        <template slot-scope="{ attrs }">
                                          <v-menu
                                            ref="pickerTime"
                                            v-model="pickerTime"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="pickerTime"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ on, attrs: attrActivator }">
                                              <v-text-field
                                                v-model="formTempEditQuiz.dueTime"
                                                :label="$t('form.time')"
                                                readonly
                                                v-bind="{ ...attrActivator, ...attrs }"
                                                v-on="on"
                                              >
                                                <template #append>
                                                  <svg-icon icon="clock" class="primary--text mr-3" />
                                                </template>
                                              </v-text-field>
                                            </template>

                                            <v-time-picker
                                              v-model="formTempEditQuiz.dueTime"
                                              :locale="$i18n.locale"
                                              @click:minute="pickerTime = false"
                                            />
                                          </v-menu>
                                        </template>
                                      </form-group>
                                    </v-col>
                                  </v-row>
                                </v-row>
                              </v-card-subtitle>
                              <v-card-actions>
                                <v-spacer />
                                <div class="d-flex justify-end align-center">
                                  <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="dialogEditQuiz = false">{{
                                    $t('back')
                                  }}</v-btn>
                                  <v-btn color="primary" class="btn-primary-custom" type="submit" @click="editQuizSubmit">{{ $t('submit') }}</v-btn>
                                </div>
                              </v-card-actions>
                            </form>
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <div class="divider" />
                    <v-row>
                      <v-col md="3">
                        <span class="d-block text-quiz-bottom mb-2">{{ $t('content.name_teacher') }} </span>
                        <strong class="text-quiz-bottom">{{ item.teacherName }} </strong>
                      </v-col>
                      <v-col md="3">
                        <span class="d-block text-quiz-bottom mb-2">{{ $t('menu.course') }} </span>
                        <strong class="text-quiz-bottom">{{ item.courseName }}</strong>
                      </v-col>
                      <v-col md="3">
                        <span class="d-block text-quiz-bottom mb-2">{{ $t('content.due_date') }} </span>
                        <strong class="text-quiz-bottom"> {{ item.dueDate }}</strong>
                      </v-col>
                      <v-col md="3">
                        <span class="d-block text-quiz-bottom mb-2">{{ $t('content.due_time') }} </span>
                        <strong class="text-quiz-bottom"> {{ item.dueTime }}</strong>
                      </v-col>
                    </v-row>
                  </div>

                  <NoData v-if="!listQuizData.length" />
                </div>
              </template>
            </div>
          </template>

          <!-- quiz Rate Response -->
          <template v-if="currentMenus === 3 && type === 'teacher'">
            <!-- list rate response -->
            <template v-if="!modeBackRate">
              <div class="d-flex align-center justify-space-between mb-6">
                <div>
                  <div class="app-section-title mb-6">{{ $t('content.rate_response') }}</div>
                </div>
                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-text-field v-model="searchRate" clearable :label="$t('search')" @change="getData">
                    <template #prepend-inner>
                      <svg-icon icon="ic-search" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </div>
              </div>
              <div>
                <template>
                  <div>
                    <div class="master-quiz pa-5 mt-4" v-for="item in listRateRespons" :key="item.analyticalQuitionnaireId">
                      <v-row>
                        <v-col md="10" class="d-flex d-inline">
                          <span class="d-block text-quiz-bottom mb-2 mr-8 mt-1">{{ item.quitionnaireName }} </span>
                          <div>
                            <span class="d-block text-quiz-bottom mb-2">{{ $t('content.rate_response') }} </span>
                            <strong style="color: #00bf63;font-size: 12px;">{{ item.totalRespondent }} of {{ item.outOf }} </strong>
                          </div>
                        </v-col>
                        <v-col md="2">
                          <v-btn @click="viewRateRespons(item.analyticalQuitionnaireId)" text
                            ><svg-icon icon="view" small class="primary--text"
                          /></v-btn>
                        </v-col>
                      </v-row>
                      <div class="divider" />
                      <v-row>
                        <v-col md="3">
                          <span class="d-block text-quiz-bottom mb-2">{{ $t('content.name_teacher') }} </span>
                          <strong class="text-quiz-bottom">{{ item.teacherName }} </strong>
                        </v-col>
                        <v-col md="3">
                          <span class="d-block text-quiz-bottom mb-2">{{ $t('menu.course') }} </span>
                          <strong class="text-quiz-bottom">{{ item.courseName }}</strong>
                        </v-col>
                        <v-col md="3">
                          <span class="d-block text-quiz-bottom mb-2">{{ $t('content.due_date') }} </span>
                          <strong class="text-quiz-bottom"> {{ item.dueDate }}</strong>
                        </v-col>
                        <v-col md="3">
                          <span class="d-block text-quiz-bottom mb-2">{{ $t('content.due_time') }} </span>
                          <strong class="text-quiz-bottom"> {{ item.dueTime }}</strong>
                        </v-col>
                      </v-row>
                    </div>
                    <NoData v-if="!listRateRespons.length" />
                  </div>
                </template>
              </div>
            </template>

            <!-- back late response -->
            <template v-else>
              <div class="d-flex align-center justify-space-between mb-6">
                <div>
                  <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backMenuLate">{{ $t('back') }}</v-btn>
                </div>
                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-btn color="primary" class="btn-primary-custom mr-3" :loading="loadingExport" @click="exportPDF()">{{
                    $t('content.export_pdf')
                  }}</v-btn>
                </div>
              </div>
              <template>
                <strong class="rate-response-title-view d-flex d-block mb-4">
                  {{ dataRateResponse.quitionnaire.quitionnaireName }} - {{ dataRateResponse.quitionnaire.classroomName }}
                  {{ dataRateResponse.quitionnaire.courseName }} - {{ dataRateResponse.quitionnaire.teacherName }}
                </strong>

                <span class="text-quiz-bottom mb-2">{{ $t('menu.course') }} </span> :
                <strong class="text-quiz-bottom mr-5"> {{ dataRateResponse.quitionnaire.courseName }}</strong>
                |
                <span class="text-quiz-bottom mb-2 ml-4">{{ $t('roles.teacher') }} </span> :
                <strong class="text-quiz-bottom mr-5"> {{ dataRateResponse.quitionnaire.teacherName }}</strong>
              </template>
              <v-divider class="mt-5 mb-5" />
              <template>
                <strong class="rate-response-title-view">
                  {{ $t('content.calculate_ques') }}
                </strong>
                <v-data-table
                  hide-default-footer
                  :headers="headerCategories"
                  :items="dataRateResponse.category.categories"
                  :loading="loading"
                  class="table-custom mt-5"
                >
                  <template #no-data>
                    {{ $t('data_not_available') }}
                  </template>
                </v-data-table>
                <div class="bottom-v-data mt-1">
                  <v-row>
                    <v-col md="7"> <strong class="text-quiz-bottom ml-4">Total</strong> </v-col>
                    <v-col md="5">{{ dataRateResponse.category.total }} </v-col>
                  </v-row>
                </div>
              </template>
            </template>
          </template>

          <!-- template student -->
          <template v-if="currentMenus === 4 && type === 'student'">
            <div class="ml-5 mr-5">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addTemplate">{{
                    $t('content.create_template')
                  }}</v-btn>
                </div>

                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-text-field v-model="searchTemplate" :label="$t('search')" @change="getData" clearable>
                    <template #prepend-inner>
                      <svg-icon icon="ic-search" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
            <div v-for="item in listTemplate" :key="item.analyticalTemplateId">
              <v-row class="border-item">
                <v-col md="2" align="center">
                  <div class="mt-5 ml-5">
                    <svg-icon icon="anal_icon" width="40" height="40" class="primary--text" />
                    <v-divider vertical></v-divider>
                  </div>
                </v-col>
                <v-col md="9" class="mt-3">
                  <div class="d-block">
                    <h3 class="d-inline">
                      <span class="header-content"> {{ item.templateName }} </span>
                    </h3>
                  </div>
                  <div class="d-block">
                    <div>
                      <span class="body-content">
                        <span class="mr-3">
                          {{ $t('content.file.date_created') }}:
                          <strong>{{ item.date }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('content.by') }}:
                          <strong>{{ item.by }}</strong>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex"></div>
                </v-col>
                <v-col md="1">
                  <template>
                    <div class="pa-5">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span dark v-bind="attrs" v-on="on">
                            <svg-icon icon="ic-moreaction-black" class="mt-1" />
                          </span>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="text-dropdown" @click="useTemplate(item.analyticalTemplateId)">{{
                              $t('content.use_template')
                            }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.editable === true">
                            <v-list-item-title class="text-dropdown" @click="editTemplate(item.analyticalTemplateId)">{{
                              $t('edit')
                            }}</v-list-item-title>
                          </v-list-item>
                          <div v-if="item.editable === true">
                            <v-list-item>
                              <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item.analyticalTemplateId)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </div>

            <NoData v-if="!listTemplate.length" />
          </template>

          <!-- result student -->
          <template v-if="currentMenus === 5 && type === 'student'">
            <div class="ml-5 mr-5">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="app-section-title mb-6">{{ $t('result') }}</div>
                </div>

                <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary" />
                <div>
                  <v-text-field v-model="searchResult" :label="$t('search')" @change="getData" clearable>
                    <template #prepend-inner>
                      <svg-icon icon="ic-search" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
            <div v-for="item in listResult" :key="item.analyticalStudentId">
              <v-row class="border-item">
                <v-col md="2" align="center">
                  <div class="mt-5 ml-5">
                    <svg-icon icon="anal_icon" width="40" height="40" class="primary--text" />
                    <v-divider vertical></v-divider>
                  </div>
                </v-col>
                <v-col md="9" class="mt-3">
                  <div class="d-block">
                    <h3 class="d-inline">
                      <span class="header-content"> {{ item.templateName }} </span>
                    </h3>
                  </div>
                  <div class="d-block">
                    <div>
                      <span class="body-content">
                        <span class="mr-3">
                          {{ $t('content.file.date_created') }}:
                          <strong>{{ item.date }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('roles.teacher') }}:
                          <strong>{{ item.teachers.length ? item.teachers.toString() : '-' }}</strong>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex"></div>
                </v-col>
                <v-col md="1">
                  <template>
                    <div class="pa-5">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span dark v-bind="attrs" v-on="on">
                            <svg-icon icon="ic-moreaction-black" class="mt-1" />
                          </span>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="text-dropdown" @click="viewResult(item.analyticalStudentId)">{{
                              $t('view')
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </div>

            <NoData v-if="!listResult.length" />
          </template>
        </v-card>
        <template>
          <!-- quiz Rate Response view mode -->
          <v-card class="pa-5 mt-5" v-if="currentMenus === 3 && type === 'teacher' && modeBackRate">
            <!-- Class Performance -->
            <template v-if="currentMenus === 3 && type === 'teacher'">
              <strong class="rate-response-title-view">
                {{ $t('content.class_performance') }}
              </strong>
              <v-row>
                <v-col md="4">
                  <div class="succ-content mt-5 class-performance-left text-center pa-5">
                    <strong class="header-text">{{ $t('menu.attendance') }}</strong>
                    <div class="app-section-title mb-4 mt-5" style="color :#00bf63;">{{ dataRateResponse.classPerformance.attendance }}</div>
                    <span>{{ $t('content.session') }}</span>
                  </div>
                </v-col>
                <v-col md="8">
                  <div class="border-item">
                    <v-row>
                      <v-col md="12" class="mt-3">
                        <div class="d-flex justify-space-between">
                          <span class="body-content ml-5">{{ $t('content.maximum_value') }} </span>
                          <span class="body-content mr-5">{{ dataRateResponse.classPerformance.maximumValue }} </span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="border-item">
                    <v-row>
                      <v-col md="12" class="mt-3">
                        <div class="d-flex justify-space-between">
                          <span class="body-content ml-5">{{ $t('content.minimum_value') }} </span>
                          <span class="body-content mr-5">{{ dataRateResponse.classPerformance.minimumValue }} </span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="class-performance-total mt-5">
                    <v-row>
                      <v-col md="12" class="mt-2">
                        <div class="d-flex justify-space-between">
                          <span class="body-content ml-5">Total </span>
                          <span class="body-content mr-5">{{ dataRateResponse.classPerformance.average }} </span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-card>

          <!-- Rate Response -->
          <v-card class="pa-5 mt-5" v-if="currentMenus === 3 && type === 'teacher' && modeBackRate && dataRateResponse.rateResponses.length">
            <template v-if="currentMenus === 3 && type === 'teacher'">
              <div class="d-flex justify-space-between">
                <strong class="rate-response-title-view">
                  {{ $t('content.rate_response') }}
                </strong>
                <strong class="rate-response-title-view ml-4">
                  {{ dataRateResponse.quitionnaire.totalRespondent }} of {{ dataRateResponse.quitionnaire.outOf }}
                  {{ $t('content.rate_response') }}</strong
                >
              </div>
              <div class="mt-5" v-for="(itemParent, indexParent) in dataRateResponse.rateResponses" :key="indexParent">
                <div class="bg-col">
                  <slide-box :value="false">
                    <template #activator="{isOpen}">
                      <div class="d-flex justify-space-between">
                        <div class="d-block mt-3">
                          <h3 class="d-inline">
                            <span class="header-content">{{ itemParent.name }} </span>
                          </h3>
                        </div>
                        <div class="d-inline d-flex pa-4 justify-center">
                          <v-icon color="orange">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                        </div>
                      </div>
                      <v-divider />
                    </template>
                    <template>
                      <div class="d-flex justify-space-between mt-5" v-for="(itemChild, indexChild) in itemParent.rates" :key="indexChild">
                        <span class="body-content">{{ itemChild.categoryName }} </span>
                        <strong class="rate-response-title-view mr-5">
                          {{ itemChild.calculate }}
                        </strong>
                      </div>
                    </template>
                  </slide-box>
                </div>
              </div>
              <div class="d-flex justify-end" v-if="listRateResponsTemp.length > 3">
                <v-btn
                  color="primary"
                  class="btn-primary-custom mr-3 mt-3"
                  outlined
                  :loading="loadingRateResponse"
                  @click="getMoreRateResponse(true)"
                  >{{ $t('content.load_more') }}</v-btn
                >
              </div>
            </template>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disable="loading" @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import FileViewer from '@/components/FileViewerErapor';
import SlideBox from '@/components/SlideBox';

export default {
  name: 'MenuListAnalitic',
  components: {
    BaseTitle,
    NoData,
    FileViewer,
    SlideBox
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    }),
    listQuiz() {
      let menus = [
        { idQuizMenu: 0, name: this.$t('content.template') },
        { idQuizMenu: 1, name: this.$t('content.questionnaire') }
      ];
      return menus;
    },
    menus() {
      switch (this.type) {
        case 'teacher':
          return [
            { id: 1, name: this.$t('content.categories') },
            { id: 2, name: this.$t('content.questionnaire') },
            { id: 3, name: this.$t('content.rate_response') }
          ];
        case 'student':
          return [
            { id: 1, name: this.$t('content.categories') },
            { id: 4, name: this.$t('content.template_analytical') },
            { id: 5, name: this.$t('result') }
          ];
        default:
          return [];
      }
    },
    headerCategories() {
      return [
        { text: this.$t('content.category_name'), value: 'categoryName' },
        { text: this.$t('content.calculate'), value: 'calculate' }
      ];
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateAnalyticalTeacher({ schoolId }) {
      const currentschoolId = this.user.schoolId;
      if (schoolId == currentschoolId && this.type === 'teacher') {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Teacher' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    },
    updateAnalyticalStudent({ schoolId }) {
      const currentschoolId = this.user.schoolId;
      if (schoolId == currentschoolId && this.type === 'student') {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Student' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    },
    updateDetailAnalyticalTeacher({ schoolId, analyticalTeacherId }) {
      const currentschoolId = this.user.schoolId;
      if (localStorage.getItem('analyticalQuitionnaireId')) {
        const currentanalyticalTeacherId = localStorage.getItem('analyticalQuitionnaireId');
        if (schoolId == currentschoolId && analyticalTeacherId == currentanalyticalTeacherId) {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Teacher Detail' });
          setTimeout(() => {
            this.getData();
          }, 400);
        }
      }
    }
  },
  data: () => ({
    pickerDate: false,
    pickerTime: false,
    currentMenus: null,
    loading: false,
    loadingExport: false,
    loadingRateResponse: false,
    search: '',
    searchCategories: '',
    searchTemplate: '',
    searchRate: '',
    searchQuiz: '',
    searchResult: '',
    dialogDelete: false,
    dialogEditQuiz: false,
    currentItem: null,
    currentIdQuizMenu: null,
    listDataCategory: [],
    listTemplate: [],
    listQuizData: [],
    listRateRespons: [],
    listRateResponsTemp: [],
    listResult: [],
    formTempEditQuiz: {
      analyticalQuitionnaireId: '',
      quitionnaireName: '',
      classroomId: '',
      courseId: '',
      teacherId: '',
      dueDate: '',
      dueTime: '',
      analyticalTemplateId: ''
    },
    modeBackRate: false,
    analyticalQuitionnaireId: '',
    dataRateResponse: {
      quitionnaire: {
        analyticalQuitionnaireId: '',
        quitionnaireName: '',
        teacherName: '',
        classroomName: '',
        courseName: '',
        totalRespondent: '',
        outOf: ''
      },
      category: {
        categories: [],
        total: 0
      },
      classPerformance: {
        attendance: 0,
        maximumValue: 0,
        minimumValue: 0,
        average: 0
      },
      rateResponses: []
    },
    dialogPreview: false,
    preview: {}
  }),
  methods: {
    getData() {
      switch (this.type) {
        case 'teacher':
          this.changeData(this.$route.params.idSidebar ? parseInt(this.$route.params.idSidebar) : 1);
          this.menus = [
            { id: 1, name: this.$t('content.categories') },
            { id: 2, name: this.$t('content.questionnaire') },
            { id: 3, name: this.$t('content.rate_response') }
          ];
          break;
        case 'student':
          this.changeData(this.$route.params.idSidebar ? parseInt(this.$route.params.idSidebar) : 1);
          this.menus = [
            { id: 1, name: 'Categories' },
            { id: 4, name: 'Template Analytical' },
            { id: 5, name: 'Result' }
          ];
          break;
      }
    },
    getMoreRateResponse(check) {
      this.loadingRateResponse = true;
      this.$store
        .dispatch(
          `Analytical/getMoreRateResponse`,
          localStorage.getItem('analyticalQuitionnaireId') ? parseInt(localStorage.getItem('analyticalQuitionnaireId')) : ''
        )
        .then(data => {
          if (check) {
            this.listRateRespons = data;
          }
          this.listRateResponsTemp = data;
        })
        .finally(() => (this.loadingRateResponse = false));
    },
    changeData(id) {
      this.currentMenus = id;
      if (this.type === 'teacher') {
        this.$router.push({ name: 'AnalyticTeacherListID', params: { idSidebar: id } });
      } else {
        this.$router.push({ name: 'AnalyticStudentListID', params: { idSidebar: id } });
      }

      if (id === 1) {
        let method;
        if (this.type === 'teacher') {
          method = 'getListCategory';
        } else if (this.type === 'student') {
          method = 'getListCategoryStudent';
        }
        this.backMenuLate();
        this.loading = true;
        this.$store
          .dispatch(`Analytical/${method}`, {
            search: this.searchCategories
          })
          .then(data => (this.listDataCategory = data))
          .finally(() => (this.loading = false));
      } else if (id === 2 && this.type === 'teacher') {
        this.backMenuLate();
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListTemplate`, {
            search: this.searchTemplate
          })
          .then(data => (this.listTemplate = data))
          .finally(() => (this.loading = false));
        if (!parseInt(localStorage.getItem('currentIdQuizMenu'))) {
          this.backMenuLate();
          this.currentIdQuizMenu = 0;
          localStorage.setItem('currentIdQuizMenu', 0);
          this.changeDataQuiz(0);
        } else {
          this.currentIdQuizMenu = parseInt(localStorage.getItem('currentIdQuizMenu'));
          this.changeDataQuiz(this.currentIdQuizMenu);
        }
      } else if (id === 3 && this.type === 'teacher') {
        if (localStorage.getItem('analyticalQuitionnaireId')) {
          this.viewRateRespons(localStorage.getItem('analyticalQuitionnaireId'));
          this.getMoreRateResponse();
        }
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListRateResponse`, {
            search: this.searchRate
          })
          .then(data => (this.listRateRespons = data))
          .finally(() => (this.loading = false));
      } else if (id === 4 && this.type === 'student') {
        this.backMenuLate();
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListTemplateStudent`, {
            search: this.searchTemplate
          })
          .then(data => (this.listTemplate = data))
          .finally(() => (this.loading = false));
      } else if (id === 5 && this.type === 'student') {
        this.backMenuLate();
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListResultStudent`, {
            search: this.searchResult
          })
          .then(data => (this.listResult = data))
          .finally(() => (this.loading = false));
      }
    },
    changeDataQuiz(id) {
      this.currentIdQuizMenu = id;
      if (this.currentIdQuizMenu === 0) {
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListTemplate`, {
            search: this.searchTemplate
          })
          .then(data => (this.listTemplate = data))
          .finally(() => (this.loading = false));

        localStorage.setItem('currentIdQuizMenu', 0);
        this.currentIdQuizMenu = 0;
      } else if (this.currentIdQuizMenu === 1) {
        this.loading = true;
        this.$store
          .dispatch(`Analytical/getListQuiz`, {
            search: this.searchQuiz
          })
          .then(data => (this.listQuizData = data))
          .finally(() => (this.loading = false));

        localStorage.setItem('currentIdQuizMenu', 1);
        this.currentIdQuizMenu = 1;
      }
    },
    addCategory() {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'CreateCategoryTeacher' });
      } else {
        this.$router.push({ name: 'CreateCategoryStudent' });
      }
    },
    addTemplate() {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'CreateTemplateTeacher' });
      } else {
        this.$router.push({ name: 'CreateTemplateStudent' });
      }
    },
    viewResult(id) {
      this.$router.push({ name: 'viewResultStudent', params: { idResult: id } });
    },
    editCategory(id) {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'EditCategoryTeacher', params: { idCategory: id } });
      } else {
        this.$router.push({ name: 'EditCategoryStudent', params: { idCategory: id } });
      }
    },
    editTemplate(id) {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'EditTemplateTeacher', params: { idTemplate: id } });
      } else {
        this.$router.push({ name: 'EditTemplateStudent', params: { idTemplate: id } });
      }
    },
    useTemplate(id) {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'UseTemplateTeacher', params: { idTemplate: id } });
      } else {
        this.$router.push({ name: 'UseTemplateStudent', params: { idTemplate: id } });
      }
    },
    editQuiz(id) {
      this.loading = true;
      this.$store
        .dispatch(`Analytical/getListQuizById`, id)
        .then(ras => {
          Object.keys(this.formTempEditQuiz).forEach(form => {
            this.formTempEditQuiz[form] = ras[form];
          });
        })
        .finally(() => {
          this.dialogEditQuiz = true;
          this.loading = false;
        });
    },
    editQuizSubmit() {
      this.$store
        .dispatch(`Analytical/updateQuiz`, { ...this.formTempEditQuiz })
        .then(() => {
          this.dialogEditQuiz = false;
          this.getData();
        })
        .finally(() => (this.loading = false));
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    viewRateRespons(id) {
      this.modeBackRate = true;
      this.analyticalQuitionnaireId = id;
      localStorage.setItem('analyticalQuitionnaireId', id);
      this.$store
        .dispatch(`Analytical/getRateResponse`, id)
        .then(data => {
          this.dataRateResponse = data;
        })
        .finally(() => (this.loading = false));
    },
    backMenuLate() {
      localStorage.removeItem('analyticalQuitionnaireId');
      this.modeBackRate = false;
      this.analyticalQuitionnaireId = '';
    },
    exportPDF() {
      this.loadingExport = true;
      this.$store
        .dispatch('Analytical/download', {
          analyticalQuitionnaireId: this.dataRateResponse.quitionnaire.analyticalQuitionnaireId
        })
        .then(res => {
          var blobURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `rekap analytical ${this.dataRateResponse.quitionnaire.quitionnaireName}`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `rekap analytical ${this.dataRateResponse.quitionnaire.quitionnaireName}.pdf`,
            size: '186 KB',
            dataUpload: res.data
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);
        })
        .finally(() => (this.loadingExport = false));
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    deleteItem() {
      if (!this.currentItem) return false;
      this.loading = true;

      let method;
      if (this.currentMenus === 1) {
        if (this.type === 'teacher') {
          method = 'deleteCategory';
        } else if (this.type === 'student') {
          method = 'deleteCategoryStudent';
        }
      } else if (this.currentMenus === 2 && this.type === 'teacher') {
        if (this.currentIdQuizMenu === 0) {
          method = 'deleteTemplate';
        } else {
          method = 'deleteQuiz';
        }
      } else if (this.currentMenus === 4 && this.type === 'student') {
        method = 'deleteTempalateStudent';
      }
      this.$store
        .dispatch(`Analytical/${method}`, this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.changeData(this.currentMenus);
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.header-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
}
.role {
  &-title {
    color: #6d6d6d;
    padding-bottom: 15px;
  }

  &-list {
    list-style: none;
    margin: 0;
    padding: 0 !important;
    width: 200px;
    padding-top: 15px !important;
    border-top: 1px dashed #6d6d6d;

    li {
      margin-bottom: 10px;
      text-decoration: none;
      font-weight: 800;
      display: block;
      padding: 10px;
      color: #6d6d6d;
      font-size: 12px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      transition: background 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94), color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
      cursor: pointer;

      &.active {
        background: lighten(#ce8800, 10);
        color: #fff;
      }

      &:hover {
        background: lighten(#ce8800, 10);
        color: #fff;
      }
    }

    &-text {
      flex: 1;
    }
  }
}
.scroll {
  overflow: scroll;
  overflow-x: hidden;
  height: 20em;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.template-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.master-quiz {
  background-color: #B2EBD0;
  border-radius: 8px;
}
.divider {
  background-color: #e3e3e3;
  height: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.text-quiz-bottom {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.publish-div {
  background-color: #ffffff;
  border-radius: 8px;
  width: 109px;
  height: 36px;
}
.rate-response-title-view {
  color: #00bf63;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.bottom-v-data {
  background-color: #B2EBD0;
  border-radius: 8px;
  height: 50px;
}
.class-performance-left {
  background-color: #B2EBD0;
  border-radius: 8px;
  height: 150px;
}
.class-performance-total {
  background-color: #B2EBD0;
  border-radius: 8px;
  height: 50px;
}
.bg-col {
  background-color: #B2EBD0;
  border-radius: 8px;
  padding-left: 35px;
  padding-right: 20px;
  padding-bottom: 15px;
}
</style>
